import React, { useState } from 'react';
import styled from 'styled-components/native';

import dynamicSize from '@webtrader/core/dynamic-size';
import { useTranslation } from '@webtrader/core/i18n';
import { checkIsNative } from '@webtrader/core/validators/device';

import Text from '@/components/Text';
import { useResetPasswordRouteParams } from '@/utils/navigation';

import NavigationHeader from '../Header';
import PasswordResetForm from './Form';
import SuccessScreen from './Success';

const PasswordResetScreen: FCC = () => {
  const { t } = useTranslation();
  const { isLive = false } = useResetPasswordRouteParams() || {};
  const [success, setSuccess] = useState(false);

  const onResetSuccess = () => {
    setSuccess(true);
  };

  if (success) {
    return <SuccessScreen />;
  }

  return (
    <Screen>
      <NavigationHeader title={t('Reset Password')} />
      <HeaderDescription>
        {t('Please enter your registered email address and account ID to reset your password.')}
      </HeaderDescription>
      <PasswordResetForm isLive={isLive} onSuccess={onResetSuccess} />
    </Screen>
  );
};

export default PasswordResetScreen;

const Screen = styled.View`
  flex: 1;

  padding-start: ${({ theme }) => theme.sizes.mobile.basePaddingStart}px;
  padding-end: ${({ theme }) => theme.sizes.mobile.basePaddingEnd}px;
`;

const HeaderDescription = styled(Text)`
  text-align: ${() => (checkIsNative() ? 'left' : 'start')};
  padding: ${dynamicSize.convertSize(20)}px 0;

  color: ${({ theme }) => theme.colors.text[1]};
  font-size: ${dynamicSize.convertSize(15)}px;
`;
